<template>
    <div class="info-card">
        <div class="h4">{{ title }}</div>
        <p>{{ desc }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },

    methods: {},
    props: ['title', 'desc'],
};
</script>

<style lang="scss" scoped>
// @import "../../../styles.scss";

.info-card {
    position: relative;
    width: 180px;
    height: 180px;
    display: flex;
    margin-right: 25px;
    flex-wrap: wrap;
    background: $sovis-white;
    text-align: center;
    margin-top: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
}

.info-card .text-container {
    border-radius: 0 6px 6px 0;
    background: $sovis-white;
    padding: 10px;
}

.info-card .h4 {
    position: relative;
    color: $primary-color-hover;
    font-weight: 600;
    font-size: 36px;
    line-height: 36px;
    height: 50px;
    left: 50%;
    transform: translateX(-50%);
    top: 30px;
    border-bottom: 1px solid $primary-color-hover;
}

.info-card p {
    color: $text-color;
    font-weight: normal;
    font-size: 14px;
    padding: 10px;
    margin: 0;
}

.info-card.bigger {
    position: relative;
    width: 200px;
    height: 200px;
    display: flex;
    margin-right: 20px;
    flex-wrap: wrap;
    background: $sovis-white;
    text-align: center;
    margin-top: 0;
}
.info-card.bigger .h4 {
    position: relative;
    color: $primary-color-hover;
    font-weight: 600;
    font-size: 64px;
    line-height: 64px;
    height: 75px;
    left: 50%;
    transform: translateX(-50%);
    top: 30px;
    border-bottom: 1px solid $primary-color-hover;
}
.info-card.bigger p {
    color: $text-color;
    font-weight: 600;
    font-size: 16px;
}

@media only screen and (max-width: 760px) {
    .info-card {
        position: relative;
        width: 117px !important;
        height: 117px !important;
        display: flex;
        margin-right: 20px;
        flex-wrap: wrap;
        background: $sovis-white;
        text-align: center;
        margin-top: 17px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        flex-shrink: 0;
        flex-grow: 0;
        &.bigger {
            width: 130px !important;
            height: 130px !important;
            flex-shrink: 0;
            flex-grow: 0;
            margin: 10px 20px 10px 0;
        }
    }

    .info-card .text-container {
        border-radius: 0 6px 6px 0;
        background: $sovis-white;
        padding: 10px;
    }

    .info-card .h4 {
        position: relative;
        color: $primary-color-hover;
        font-weight: 600;
        font-size: 24px;
        line-height: 24px;
        height: 30%;
        left: 50%;
        transform: translateX(-50%);
        top: 30px;
        border-bottom: 1px solid $primary-color-hover;
        margin-top: -7px;
    }

    .info-card p {
        color: $text-color;
        font-weight: normal;
        font-size: 9px !important;
        padding: 7px;
        margin-top: 15px !important;
    }

    .info-card.bigger .h4 {
        position: relative;
        color: $primary-color-hover;
        font-weight: 600;
        font-size: 48px;
        line-height: 48px;
        height: 45%;
        left: 50%;
        transform: translateX(-50%);
        top: 30px;
        border-bottom: 1px solid $primary-color-hover;
        margin-top: -26px;
    }
    .info-card.bigger p {
        color: $text-color;
        font-weight: 600;
        font-size: 13px !important;
        margin-top: 19px !important;
        padding: 10px;
    }
}
</style>
